import { TablePagination } from '@mui/material'
import { PaginationUpdateProps } from './types'
interface ListViewPaginationProps {
  count: number
  pageIndex: number
  rowsPerPage: number
  update: (input: PaginationUpdateProps) => void
}
export const ListViewPagination = ({
  count,
  pageIndex,
  rowsPerPage,
  update,
}: ListViewPaginationProps) => {
  const handleChangePage = (
    _event: React.MouseEvent<HTMLButtonElement> | null,
    newPageIndex: number,
  ) => {
    update({ pageIndex: newPageIndex, pageSize: rowsPerPage })
  }
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const newPageSize = parseInt(event.target.value, 10)
    update({ pageIndex: 0, pageSize: newPageSize })
  }
  return (
    <TablePagination
      component='div'
      count={count ?? 0}
      showFirstButton={true}
      showLastButton={true}
      page={pageIndex >= 0 ? pageIndex : 0}
      onPageChange={handleChangePage}
      rowsPerPage={rowsPerPage}
      rowsPerPageOptions={[50, 100, 250, 500, 1000]}
      onRowsPerPageChange={handleChangeRowsPerPage}
    />
  )
}
